export default "__VITE_ASSET__DdMs_7bc__"